import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_has_overdue_social_insurance_social_security_debts'

export const dataPointDefinition = {
  retracedId: 'facility_has_overdue_social_insurance_social_security_debts',
  name: 'If the facility has overdue social insurance / social security debts due to non-payment or untimely payment of contribut',
  description:
    '"Actively correcting" means there is a valid agreement in place to address the overdue debts, and the facility is implementing the agreement correctly, i.e., the facility is following the valid agreement. ',
  meta: {
    slcpMeta: {
      key: 'wb-wage-90',
      number: 'WB-WAGE-139',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-90', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36190,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
